import axios, { endpoints } from 'src/utils/axios';

export const contactApi = {
  sendContactMessage: async (data) => {
    const response = await axios.post(endpoints.common.contact, data);
    return response.data;
  },
};
